'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Archive = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class, _temp, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _form = require('antd/lib/form');

var _form2 = _interopRequireDefault(_form);

var _row = require('antd/lib/row');

var _row2 = _interopRequireDefault(_row);

var _col = require('antd/lib/col');

var _col2 = _interopRequireDefault(_col);

var _icon = require('antd/lib/icon');

var _icon2 = _interopRequireDefault(_icon);

var _customForm = require('../customForm');

var _Divider = require('material-ui/Divider');

var _Divider2 = _interopRequireDefault(_Divider);

require('./index.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var IArchive = (_temp = _class = function (_React$PureComponent) {
  _inherits(IArchive, _React$PureComponent);

  function IArchive(props, context) {
    _classCallCheck(this, IArchive);

    var _this = _possibleConstructorReturn(this, (IArchive.__proto__ || Object.getPrototypeOf(IArchive)).call(this, props, context));

    _this.toggle = function () {
      _this.setState({ expand: !_this.state.expand });
    };

    _this.handleSubmit = function (e) {
      e && e.preventDefault();
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          _this.props.options.forEach(function (option) {
            if (option.getValue) {
              var name = option.dataIndex || option.name;
              values[name] = option.getValue(values[name]);
            }
          });
          _this.props.onSubmit && _this.props.onSubmit(values);
        }
      });
    };

    _this.state = {
      expand: !props.limit || props.limit > props.options.length,
      dataSource: _this.props.dataSource
    };
    return _this;
  }

  _createClass(IArchive, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      if (nextProps.dataSource !== this.props.dataSource) {
        this.setState({ dataSource: nextProps.dataSource });
      }
    }
  }, {
    key: 'getFieldValue',
    value: function getFieldValue(name, option, editable) {
      var value = void 0;
      if (this.state.dataSource[name] === undefined) {
        value = option.value;
      } else {
        value = this.state.dataSource[name];
      }
      if (this.props.formatter) {
        return this.props.formatter(value, option);
      } else {
        if (editable) {
          return option.renderInput ? option.renderInput(value, this.state.dataSource) : value;
        } else {
          return option.render ? option.render(value, this.state.dataSource) : value;
        }
      }
    }
  }, {
    key: 'getFieldInput',
    value: function getFieldInput(name, option) {
      var _this2 = this;

      var _props = this.props,
          form = _props.form,
          readonly = _props.readonly,
          onChange = _props.onChange;

      var editable = option.editable === undefined ? !readonly : option.editable;

      if (editable) {
        /**
         * option = {
         *  dataType | type,
         *  enum,
         *  options,
         *  format,
         *  mode,
         *  dragger,
         *  action,
         *  valuePropName,
         *  Component,
         *  max,
         *  maxLength,
         *  maximum,
         *  disabled,
         *  placeholder
         * }
         */
        var decorator = option.decorator || {};
        if (onChange) {
          decorator.getValueFromEvent = function (e) {
            var v = _customForm.CustomForm.getValueFromEvent(e, option);
            onChange(v, name);
            return v;
          };
        }
        decorator.defaultValue = this.getFieldValue(name, option, editable);
        var stateProps = option.getProps && option.getProps.call(this, this.props, this.state.dataSource, function (nextState) {
          _this2.setState({
            dataSource: Object.assign({}, _this2.state.dataSource, nextState)
          });
        }, this.props.form);
        if (stateProps === false) return null;
        var fieldInput = _customForm.CustomForm.getFieldInput(option, option.props, stateProps || {}, decorator);
        return form.getFieldDecorator(name, decorator)(fieldInput);
      } else {
        return this.getFieldValue(name, option);
      }
    }
  }, {
    key: 'getFields',
    value: function getFields() {
      var _props2 = this.props,
          options = _props2.options,
          limit = _props2.limit,
          cols = _props2.cols,
          formItemLayout = _props2.formItemLayout,
          compact = _props2.compact,
          noLabel = _props2.noLabel;

      var span = Math.floor(24 / cols);
      var count = this.state.expand ? options.length : limit;
      // const {getFieldDecorator} = form;
      var fields = [];
      var itemStyle = compact ? { marginBottom: 0 } : {};
      var item = void 0;
      var name = void 0;
      var label = void 0;
      var input = void 0;
      for (var i = 0; i < count; i++) {
        item = options[i];
        if (item && (item.dataIndex || item.name)) {
          name = item.dataIndex || item.name;
          label = noLabel ? null : item.title || item.name;
          input = this.getFieldInput(name, item);
          if (input) {
            fields.push(_react2.default.createElement(
              _col2.default,
              { span: item.col ? item.col * span : item.span || span, key: name, style: { display: i < count ? 'block' : 'none' } },
              _react2.default.createElement(
                _form2.default.Item,
                _extends({}, formItemLayout, item.attrs, { label: label, style: itemStyle }),
                input
              )
            ));
          }
        }
      }
      return fields;
    }
  }, {
    key: 'getButtons',
    value: function getButtons() {
      var _props3 = this.props,
          buttons = _props3.buttons,
          buttonProps = _props3.buttonProps;

      if (buttonProps.onSubmit) {
        buttonProps.onSubmit.bind(this.state.dataSource);
      } else {
        buttonProps.onSubmit = this.handleSubmit;
      }
      var justify = buttonProps.align || 'end';
      var _buttons = _customForm.CustomForm.getButtons(buttons, buttonProps);
      return _buttons ? _react2.default.createElement(
        _row2.default,
        { justify: justify, type: 'flex', className: 'o-com-archive_btns', style: buttonProps.btnStyle },
        _buttons
      ) : null;
    }
  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _form2.default,
        { className: 'o-com-archive ' + this.props.className, style: this.props.style, layout: this.props.layout, onSubmit: this.props.buttonProps.noButton && this.handleSubmit },
        _react2.default.createElement(
          _row2.default,
          { gutter: 24 },
          this.getFields(),
          this.props.limit && this.props.limit < this.props.options.length ? _react2.default.createElement(
            'a',
            { className: 'o-com-archive_expand', onClick: this.toggle },
            'more ',
            _react2.default.createElement(_icon2.default, { type: this.state.expand ? 'up' : 'down' })
          ) : null
        ),
        this.getButtons()
      );
    }
  }]);

  return IArchive;
}(_react2.default.PureComponent), _class.propTypes = {
  options: _propTypes2.default.array,
  dataSource: _propTypes2.default.object,
  limit: _propTypes2.default.number,
  form: _propTypes2.default.object,
  cols: _propTypes2.default.number,
  readonly: _propTypes2.default.bool,
  compact: _propTypes2.default.bool,

  layout: _propTypes2.default.string,
  formItemLayout: _propTypes2.default.object,
  onChange: _propTypes2.default.func,
  onSubmit: _propTypes2.default.func,
  formatter: _propTypes2.default.func,
  noLabel: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  className: _propTypes2.default.string,

  buttons: _propTypes2.default.array,
  buttonProps: _propTypes2.default.object
}, _class.defaultProps = {
  options: [],
  dataSource: {},
  cols: 3,
  readonly: true,
  compact: false,
  buttonProps: { noButton: true },
  className: '',
  style: {}
}, _temp);
var ArchiveGroup = (_temp2 = _class2 = function (_React$PureComponent2) {
  _inherits(ArchiveGroup, _React$PureComponent2);

  function ArchiveGroup() {
    _classCallCheck(this, ArchiveGroup);

    return _possibleConstructorReturn(this, (ArchiveGroup.__proto__ || Object.getPrototypeOf(ArchiveGroup)).apply(this, arguments));
  }

  _createClass(ArchiveGroup, [{
    key: 'render',
    value: function render() {
      var _this4 = this;

      return _react2.default.createElement(
        'div',
        { className: 'o-com-archive-group' },
        this.props.options.map(function (item) {
          return _react2.default.createElement(
            'div',
            { key: item.name, className: 'o-com-archive-group_box' },
            _react2.default.createElement(
              'h5',
              null,
              item.title || item.name
            ),
            _react2.default.createElement(_Divider2.default, null),
            _react2.default.createElement(Archive, _extends({}, item.attrs, _this4.props, { options: item.items, dataSource: _this4.props.dataSource[item.name] }))
          );
        })
      );
    }
  }]);

  return ArchiveGroup;
}(_react2.default.PureComponent), _class2.propTypes = {
  options: _propTypes2.default.array,
  dataSource: _propTypes2.default.object
}, _class2.defaultProps = {
  options: [],
  dataSource: {}
}, _temp2);
var Archive = exports.Archive = _form2.default.create({ name: 'archive' })(IArchive);
Archive.Group = ArchiveGroup;


//////////////////
// WEBPACK FOOTER
// ./src/components/archive/index.jsx
// module id = 63
// module chunks = 0